<template>
  <div style="display: flex;align-items:center">
      <div class="prev" style="color: #fff" @click="prev" v-if="isShowScroll">
      <img src="@/assets/img/menu/menuPrev11.png" alt="" >

    </div>
    <div
      class="menuBox"
      ref="scrollLeft"
      :class="{
        menuBoxThree: menuList.length == 0,
        menuBoxFour: menuList.length == 1,
        menuBoxFive: menuList.length == 2,
        menuBoxMore: isShowScroll,
      }"
    >
      <!-- <dv-border-box-10> -->
      <div class="menu_item tabBtn" style="margin-left: 0" @click="gopages(1)">
        <img src="@/assets/img/home/dataIcon.png" alt="" />
        <div class="menu_name">数据大屏</div>
      </div>
      <!-- </dv-border-box-10> -->
      <template v-for="(item, index) in menuList">
        <!-- <dv-border-box-10 :key="index"> -->
        <div
          class="menu_item tabBtn"
          :class="['tabBtn' + index]"
          @click="gopage(item)"
          :key="index"
        >
          <!-- <i class="iconfont icon-wangluo"></i> -->
          <img
            src="@/assets/img/home/seoIcon.png"
            alt=""
            v-if="item.tb == 'master'"
          />
          <img
            src="@/assets/img/home/videoIcon.png"
            alt=""
            v-if="item.tb == 'dsp'"
          />
		  
		  <img
		    src="@/assets/img/home/custom.png"
		    alt=""
		    v-if="item.tb == 'crm'"
		  />
          <div class="menu_name">{{ item.label }}</div>
        </div>

        <!-- </dv-border-box-10> -->
      </template>
      <!-- <div class="menu_item tabBtn tabBtn5">
      
        <div class="menu_name">test</div>
      </div>
      <div class="menu_item tabBtn tabBtn6">

        <div class="menu_name">test</div>
      </div> -->
     <!-- <div class="menu_item tabBtn tabBtn7">
        <img src="@/assets/img/home/custom.png" alt="" />
        <div class="menu_name">客户管理</div>
      </div> -->
      <div class="menu_item tabBtn tabBtn7" @click="gopages(10000)">
        <img
          src="@/assets/img/home/marketing.png"
          alt=""
          style="position: relative; top: 5px; width: 32px"
        />
        <div class="menu_name">营销课堂</div>
      </div>
    </div>
    <div class="next" style="color: #fff" @click="next" v-if="isShowScroll">
      <img src="@/assets/img/menu/menuNext11.png" alt="">

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 1,
      menuList: [],
      isShowScroll:false,
	  form: {},
    };
  },
  created() {
    this.getTikTokStationJoinSysUser();
  },
  mounted(){
     setTimeout(()=>{
       console.log(this.$refs.scrollLeft.scrollWidth,this.$refs.scrollLeft.clientWidth);
       if(this.$refs.scrollLeft.scrollWidth>this.$refs.scrollLeft.clientWidth){
        console.log('需要显示滚动条');
        this.isShowScroll=true
       }
     },500)
     
window.onresize=()=>{
  console.log('大小改变');
      setTimeout(()=>{
       console.log(this.$refs.scrollLeft.scrollWidth,this.$refs.scrollLeft.clientWidth);
       if(this.$refs.scrollLeft.scrollWidth>this.$refs.scrollLeft.clientWidth){
        console.log('需要显示滚动条');
        this.isShowScroll=true
       }else{
        this.isShowScroll=false
       }
     },100)

}
  },
  methods: {
    getTikTokStationJoinSysUser() {
      this.$http
        .getTikTokStationJoinSysUser(
          JSON.parse(localStorage.getItem("userInfo")).userId
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.menuList = res.data.data;
            // this.menuList.push({
            //   label: "ant0538站",
            //   mainStation: "https://seo.ant0538.com/admin",
            // });
            // this.menuList.pop()
          }
        });
    },
	doLogin(item){
		console.log("------------");
		console.log(this.form);
		this.$http.doLogin(this.form).then((res) => {
		  console.log("data", res);
		  let data = res.data;
		  if (data.code == 200) {
			let token = data.token;
		    console.log("打印返回值");
			console.log(data.data.token);
			if(item.tb == "master"){
				//{"last_time":1702115017,"ADMIN_ID":1,"name":"adminqy","token":"98660c71218290dd4d212d90297d19a73af2cd9acf81fb6d6fc0de1caabf7905"}
				window.open(item.mainStation+"/public/login?token="+data.data.token+"&last_time="+data.data.last_time+"&ADMIN_ID="+data.data.ADMIN_ID+"&name="+data.data.name);
				//window.open('.$url.',"_blank")
			}
			if(item.tb == "dsp"){
				//alert(item.mainStation);
				//alert(data.data.data.access_token);
				window.open("https://video.ourqiyi.com/login?redirect=%2Findex&token="+data.data.data.access_token+"&expires="+data.data.data.expires_in,"_blank")
				//window.open("https://video.ourqiyi.com/index?t="+data.data.data.access_token)
			}
			if(item.tb == "crm"){
				//alert(item.mainStation);
				//alert(data.data.__token__);
				//alert(data.data.username);
				//alert(data.data.password);
				//post调登录然后跳转
				console.log("http://crm.ourqiyi.com/feazwdlnOj.php/index/login?token="+data.data.__token__+"&username="+data.data.username+"&password="+data.data.password);
				window.open("http://crm.ourqiyi.com/feazwdlnOj.php/index/login?token="+data.data.__token__+"&username="+data.data.username+"&password="+data.data.password)
			}
		  } else {
			this.$message.error(data.msg);
		  }
		});	
	},
    gopage(item) {
      console.log(item);
      this.activeIndex = item.id;
        // this.activeIndex = 1;
		//根据点击按钮的id做跳转，后台调取成功再走前台跳转，防止密码泄露
      this.form = item;
      console.log(this.form);
      this.doLogin(item);
    },
	gopages(item){
		console.log(item);
		if (item == 1) {
		  location.reload();
		  return false;
		}
		if (item == 10000) {
		  window.open("http://kecheng.ourqiyi.com");
		  return false;
		}
	},
    next() {
      console.log("点我滚l");
      console.log(this.$refs);
      this.$refs.scrollLeft.scrollBy({
        left: 1000, // 每次点击滚动的距离
        behavior: "smooth",
      });
      // this.$refs.scrollLeft.scrollLeft=100
    },
    prev() {
      console.log("点我滚l");
      console.log(this.$refs);
      this.$refs.scrollLeft.scrollBy({
        left: -1000, // 每次点击滚动的距离
        behavior: "smooth",
      });
      // this.$refs.scrollLeft.scrollLeft=100
    },
  },
};
</script>
<style scoped>
.next{
  cursor: pointer;
  position: relative;
  left:-20px;
}
.prev{
    cursor: pointer;
  position: relative;
  right:-20px;
}
/* 
 滚动条样式设置  */
.menuBox ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: rgb(4, 27, 143);
}

.menuBox::-webkit-scrollbar {
  display: none;
  height: 10px;
  /* background-color: rgba(0, 0, 0, 0.8);
   */
  background-color: rgb(4, 27, 143);
}

.menuBox::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 2px rgba(81, 167, 255, 0.3);
  background-color: rgba(81, 167, 255, 0.8);
}
</style>
<style lang='scss' scoped>
$bgColor: rgb(9, 22, 88);
i {
  font-size: 50px;
  color: rgb(61, 96, 246);
}
.menuBox {
  width: 100%;
  background: $bgColor;
  display: flex;
  justify-content: space-between;
  // padding: 35px 40px 30px;
  padding-bottom: 0;

  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  margin: 30px 40px;
  // margin-right: 0;
  .dv-border-box-10 {
    width: 270px;
    height: 80%;
    margin-right: 20px;
  }
}
.menuBoxThree {
  justify-content: flex-start;
  .menu_item {
    min-width: 220px;
  }
}
.menuBoxFour {
  justify-content: space-between;
  .menu_item {
    width: 22%;
  }
}
.menuBoxFive{
  justify-content: space-between;
  .menu_item {
    width: 18%;
  }
}
::v-deep .dv-border-box-10 {
  width: auto;
  box-shadow: rgb(29, 72, 196) 0px 0px 50px 3px inset !important ;
  margin-bottom: 20px;
}

::v-deep .dv-border-box-10 .right-bottom {
  display: none;
}
::v-deep .dv-border-box-10 .left-bottom {
  display: none;
}
::v-deep .dv-border-box-10 .right-top {
  display: none;
}

.menu_item {
  // flex: 1;
  min-width: 300px;
  box-sizing: border-box;
  padding: 27px 40px;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.07);
  background-image: linear-gradient(271deg, #ed69b1 0, #b800b3 100%);
  border-radius: 12px;
  height: 80px;
  margin-left: 27px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #fff;
  text-align: center;
  .menu_name {
    margin-left: 10px;
    font-size: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
  }
  i {
    color: #fff;
  }
}
.tabBtn {
  justify-content: center;
  // background: url('@/assets/img/home/button1.png') no-repeat;

  background-size: 100% 100%;
  // margin-left: 0;
}
.tabBtn1 {
  background-image: linear-gradient(271deg, #9199f4 0, #545ba3 100%);
  // background: url('@/assets/img/home/button4.png') no-repeat;
  // background-image: linear-gradient(271deg, #9199f4 0, #545ba3 100%);
  background-size: 100% 100%;
}
.tabBtn0 {
  background-image: linear-gradient(
    271deg,
    rgba(243, 182, 82, 1) 0,
    rgba(220, 131, 43, 1) 100%
  );

  // background: url('@/assets/img/home/button2.png') no-repeat;
  background-size: 100% 100%;
}
.tabBtn2 {
  background-image: linear-gradient(271deg, #c3f5c3 0, #66ca98 100%);
  // background: url('@/assets/img/home/button4.png') no-repeat;
  background-size: 100% 100%;
}
.tabBtn3 {
  background-image: linear-gradient(271deg, #f45298 0, #ce1d64 100%);
  // background: url('@/assets/img/home/button5.png') no-repeat;
  background-size: 100% 100%;
}
.tabBtn4 {
  background-image: linear-gradient(271deg, #078dec 0, #2966dc 100%);
  // background: url('@/assets/img/home/button6.png') no-repeat;
  background-size: 100% 100%;
}
.tabBtn5 {
  background-image: linear-gradient(
    271deg,
    rgb(224, 99, 149) 0,
    rgb(201, 42, 54) 100%
  );
  // background: url('@/assets/img/home/button7.png') no-repeat;
  background-size: 100% 100%;
}
.tabBtn7 {
  background-image: linear-gradient(271deg, #41bdc6 0, #4694c5 100%);
  // background: url('@/assets/img/home/button7.png') no-repeat;
  background-size: 100% 100%;
}
.tabBtn6 {
  background-image: linear-gradient(271deg, rgb(255, 166, 107) 0, #f60 100%);
  // background: url('@/assets/img/home/button7.png') no-repeat;
  background-size: 100% 100%;
}
.tabBtn8 {
  background-image: linear-gradient(271deg, #c3f5c3 0, #66ca98 100%);
  // background: url('@/assets/img/home/button7.png') no-repeat;
  background-size: 100% 100%;
}
.menu_item:hover {
  // box-shadow: #303133;
  box-shadow: 0 0 10px rgba(61, 96, 246, 0.6);
  // color: rgba(61,96,246,0.6);
  // color: #12006a
}
//
.menu_active {
  color: #fff;

  //  box-shadow: rgb(141, 29, 134,.9) 0px 0px 70px 3px inset!important ;
  i {
    font-size: 50px;
    color: #fff;
  }
}
</style>